// assets/collection-link-context.js
(function () {
  function getCollectionHandle() {
    return (window.__COLLECTION_HANDLE__ || "").trim();
  }

  function toAbsoluteUrl(href) {
    try {
      return new URL(href, window.location.origin);
    } catch {
      return null;
    }
  }

  function isSameOrigin(url) {
    return url && url.origin === window.location.origin;
  }

  function extractProductHandle(pathname) {
    if (!pathname) return "";
    if (pathname.startsWith("/products/")) {
      const parts = pathname.split("/").filter(Boolean);
      return parts[1] || "";
    }
    if (pathname.startsWith("/collections/") && pathname.includes("/products/")) {
      const parts = pathname.split("/").filter(Boolean);
      const i = parts.indexOf("products");
      return i !== -1 ? (parts[i + 1] || "") : "";
    }
    return "";
  }

  function buildForcedHref(rawHref, collectionHandle) {
    const url = toAbsoluteUrl(rawHref);
    if (!url || !isSameOrigin(url)) return null;

    const productHandle = extractProductHandle(url.pathname);
    if (!productHandle) return null;

    const forced = new URL(window.location.origin);
    forced.pathname = `/collections/${collectionHandle}/products/${productHandle}`;

    // conserver params existants (variant, etc.)
    url.searchParams.forEach((v, k) => forced.searchParams.set(k, v));

    // forcer from_collection
    forced.searchParams.set("from_collection", collectionHandle);

    forced.hash = url.hash || "";

    return forced.pathname + (forced.search || "") + (forced.hash || "");
  }

  function rewriteAll(collectionHandle, root) {
    const scope = root || document;
    const links = scope.querySelectorAll ? scope.querySelectorAll("a[href]") : [];
    links.forEach((a) => {
      const rawHref = a.getAttribute("href");
      if (!rawHref) return;
      if (
        rawHref.startsWith("#") ||
        rawHref.startsWith("mailto:") ||
        rawHref.startsWith("tel:") ||
        rawHref.startsWith("javascript:")
      ) {
        return;
      }

      const forced = buildForcedHref(rawHref, collectionHandle);
      if (forced) a.setAttribute("href", forced);
    });
  }

  function interceptClicks(collectionHandle) {
    document.addEventListener(
      "click",
      function (e) {
        if (e.defaultPrevented) return;
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const t = e.target instanceof Element ? e.target : null;
        if (!t) return;

        const a = t.closest && t.closest("a[href]");
        if (!a) return;

        const rawHref = a.getAttribute("href");
        if (!rawHref) return;

        const forced = buildForcedHref(rawHref, collectionHandle);
        if (!forced) return;

        // Bloque les handlers du thème et force l’URL correcte
        e.preventDefault();
        e.stopPropagation();
        window.location.assign(forced);
      },
      true
    );
  }

  function run() {
    const collectionHandle = getCollectionHandle();
    if (!collectionHandle) return;

    rewriteAll(collectionHandle, document);
    interceptClicks(collectionHandle);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (!m.addedNodes || !m.addedNodes.length) continue;
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          rewriteAll(collectionHandle, node);
        });
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
